module.exports = __webpack_public_path__ + "static/media/background_preload_home_page.add39875.jpg";